import { Grid } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, getLocalValue, handleApiError, IsSmallScreen, LoacalVariables, Method } from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import TaskDrawyer from "../../Contacts/ContactDetails/DrawyerPages/TaskDrawyer";
import { ITask } from "../../DTO/Dto";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../../Components/DataGrid/WSMobileDataGridAdvanced";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";

export const OverViewTask: React.FC<any> = React.memo((props) => {
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
  const { id } = params
  const [openF, setOpen] = React.useState(false);
  const [taskListData, setTaskListData] = useState<any>([])
  const [resetLoad, setResetLoad] = useState(false)
  const [loading, setLoading] = useState(false)
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [formComponent, setFormComponent] = useState<any>()
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getTaskPermission;
  const resetTrigger = useSelector((state: any) => state.components?.TaskGrid?.resetTrigger);
  const isMobile = IsSmallScreen();
  useEffect(() => {

    const getTasks = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI(`tasks/lead`, Method.GET, null, id);
        if (response && response.data) {
          setTaskListData(response.data);
        }
      }
      catch (e) {
      }
    }
    getTasks();
  }, [resetTrigger])
  useEffect(() => {

    const getTasks = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI(`tasks/lead`, Method.GET, null, id);
        if (response && response.data) {
          setTaskListData(response.data);
        }
      }
      catch (e) {
      }
    }
    getTasks();
  }, [resetLoad])
  const columns: IColumns[] = [
    {
      header: "Task",
      fieldName: "taskName",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Task Date",
      fieldName: "customDate",
      tooltip: true,
      type: 'date'
    },
    {
      header: "Task type",
      fieldName: "taskType",
      tooltip: true,
      type: 'default',
      isHide: isMobile
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, remove ? "Delete" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Task",
      fieldName: "taskName",
      tooltip: true,
      type: 'default',
      sm: 6
    },
    {
      header: "Task Date",
      fieldName: "customDate",
      tooltip: true,
      type: 'date',
      sm: 6
    },
    {
      header: "Task type",
      fieldName: "taskType",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ];
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      const form: any = <TaskDrawyer
        id={id}
        control={control}
        register={register}
        loading={loading}
        taskId={row.id}
        data={row}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}

      />

      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);
    } else if (action === "Delete") {
      openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
    }
  }
  const handleDelete = async (id?: string | number) => {
    const response: any = await callAPI(`tasks`, Method.DELETE, null, id);
    dispatch(resetDataComponent('TaskGrid'));
    setResetLoad(true)
    if (response?.success) {
      showMessage(response?.message, "success")
    }
    else {
      showMessage(response?.message || 'Something went wrong', "error")
    }
    handleClose()

  };
  const handleTasksData = async (data: any) => {
    try {
      dispatch(storeDataComponent('taskSubmit', { loading: true }));
      const response: any = await saveData(data);
      if (response?.errors) {
        const mess = handleApiError(response)
        showMessage(mess, 'error');
      }
      else if (response && response?.message) {
        dispatch(resetDataComponent('TaskGrid'));
        reset()
        setResetLoad(true)
        showMessage(response.message, response.success === true ? 'success' : 'error')
      } else if (response?.id) {
        dispatch(resetDataComponent('TaskGrid'));
        setResetLoad(true)
        showMessage('Task Created Successfully', 'success')
      }
    } catch (e: any) {
      showMessage(e.error);
      setResetLoad(true)
    }
    finally {
      dispatch(updateDataComponent('taskSubmit', { loading: false }));
    }
  }
  const saveData = async (data: ITask) => {
    const isoString: any = dayjs(`${data?.customDate} 00:00`, "DD-MM-YYYY HH:mm").toISOString();
    const request: ITask = {
      taskName: data?.taskName || "",
      activityDate: data?.activityDate?.toString() || "",
      activityTime: data?.activityTime || "",
      customDate: isoString || "",
      assignedToUserId: data?.assignedToUserId || getLocalValue(LoacalVariables.UserId),
      leadId: id || "",
      customReminderTime: data.customReminderTime,
      notes: data?.notes || "",
      priority: data?.priority || "",
      queue: data?.queue || "",
      reminder: data?.reminder?.toString() || "",
      reminderSent: data?.reminderSent || false,
      taskType: data?.taskType || "",

    }
    if (data?.taskId) {
      const response: any = await callAPI("tasks", Method.PUT, request, data?.taskId);
      return response
    } else {
      const response: any = await callAPI("tasks", Method.POST, request);
      return response
    }

  }

  const handleTaskClick = () => {
    const form: any = <TaskDrawyer
      id="taskEditAdd"
      control={control}
      loading={loading}
      register={register}
      reset={reset}
      setValue={setValue}
      onCancel={() => { reset(); setOpen(false) }}
    />
    setFormComponent(form)
    setTimeout(() => {
      setOpen(true)
    }, 10);

  }

  return (
    <    >
      <Grid container spacing={0} sx={{ p: 0, borderRadius: 5 }}>
        {view ? <Grid item xs={12}>
          {<WSDataGrid
            id="TaskGrid"
            isAccordian={true}
            title="Tasks"
            data={taskListData}
            columns={columns}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleTaskClick}

          />}
          {/* {isMobile && taskListData.length>0 &&
            <WSMobileDataGridAdvanced title={'Tasks'} addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleTaskClick} columns={mobColumns} id="estimationGrid" data={taskListData} />
          } */}
        </Grid>
          : <PermissionDenied />}
      </Grid>
      {formComponent && <SwipeableDrawerForm anchor="right" title={'Tasks'} isMobile={isMobile}
        openForm={openF}
        formComponent={<form onSubmit={handleSubmit(handleTasksData)}>
          {formComponent}
        </form>}
        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

      />
      }
      <ConfirmDialog
        open={open}
        title={title}
        onConfirm={onConfirm}
        onClose={handleClose}
      />
    </>
  );
});
